import axios from 'src/utils/httpClients/axios';

import { HOST_API, AUTH0_API } from 'src/config';

// -----------------------------------------------------------

type RangeDate = {
  startDate: string;
  endDate: string;
};

const baseUrl = `${HOST_API}Sift/user/action/count`;
const identityUrl = `${AUTH0_API.domain}api/companies/tenantActionsCount`;

async function getTenantStatistics(rangeDate: RangeDate) {
  const settings = {
    params: {
      ...rangeDate,
    },
    headers: {
      'Accept-Language': 'en',
    },
  };

  const response = await axios.get(identityUrl, settings);

  return {
    ...response.data.signatureAuth,
    ...response.data.fileStatistics,
  };
}

async function getSignatureAuthFilesCounts(email: string | undefined, rangeDate: RangeDate) {
  const settings = {
    params: {
      ...rangeDate,
    },
  };

  const response = await axios.get(`${baseUrl}/${email}`, settings);

  const dataToShow = {
    ...response.data.signatureAuth,
    ...response.data.fileStatistics,
  };

  return dataToShow;
}

const dashboardB2BAnalyticsService = {
  getSignatureAuthFilesCounts,
  getTenantStatistics,
};

export default dashboardB2BAnalyticsService;
